import client from '../client';

export interface PackagingItemState {
  ActionId: number;
  ActionName: string;
  Summary: string;
  CreateDate: string;
}

export interface PackagingItem {
  Id: number;
  Ordinal: number;
  PartNumber: string;
  Type: string;
  State: PackagingItemState;
}

export interface PackagingOrder {
  OrderNumber: string;
  CustomerId: string;
  BillToName: string;
  OrderDate: string;
  Age: number;
  ItemCount: number;
  Items: PackagingItem[];
}

export const packagingService = {
  /**
   * Get all items in packaging/trimming stage
   */
  getPackagingItems: async (): Promise<PackagingOrder[]> => {
    const response: any = await client.get('/packaging/items');
    return response.data;
  }
};
